import React from 'react';

export function MissingPage404() {
    return (
        <>
            <h1 style={{textAlign: 'center'}}>404: Missing page</h1>
        </>
    );
}
